import { FC } from 'react';
import { Icon } from '@pypestream/design-system';

import './resource-library-fab.scss';

/**
 * The Build stage's floating "Resource Library" pill — the prototype's
 * `.fab-library` (`prostudio-build-flow-layouts.html`). Positioned by the
 * surface that renders it, inside that surface's own area, so docked panels
 * beside the surface push it aside instead of covering it.
 */
export const ResourceLibraryFab: FC<{
  active?: boolean;
  className?: string;
  onClick: () => void;
}> = ({ active, className, onClick }) => (
  <button
    type="button"
    className={['c-resource-library-fab', className, active && 'is-active']
      .filter(Boolean)
      .join(' ')}
    aria-pressed={active}
    data-testid="bobcat-resource-library-fab"
    onClick={onClick}
  >
    <span className="c-resource-library-fab__mark">
      <Icon name="microagent" size="small" />
    </span>
    <Icon name="grid-menu" size="xsmall" />
    Resource Library
  </button>
);
